import angular from "angular";
import { Subject } from "@common/model/subject";
import { User } from "@common/model/user";
import { CacheService } from "@common/service/cache.service";
import { TeamVaultService } from "@common/service/teamvault.service";
import { IUserService } from "@common/service/user.service";
import { ICachingService } from "@common/service/caching.service";
import { ITeamRoleService } from "@common/service/teamRole.service";
import { PostTypeEnums } from "@common/model/_adocument";
import { Util } from "@common/util";
import { DocumentFolder, FolderStatusCodes, FolderTypeCodes } from "@common/model/documentFolder";
import { FOLDER_MODULES, FORMS_MODULE, ORGANIZE_MODULE } from "@common/model/constants";
import { PermissionsEnum, TargetEnum } from "ecv/common/permissions";
import { CommonService } from "@common/common.service";
import { PopUpService } from "@common/popup/popup.service";
import { IAppRootScopeService } from "@app/app.definition";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { PaymentService } from "@common/service/payment.service";
import { DocumentFolderService } from "@common/itemBoard/components/itemFolder/services/documentFolder.service";
import { UtilityService } from "@common/service/util.service";
import { PermissionService } from "ecv/common/permissions";
import { SnackbarService } from "@common/service/snackbar.service";
import { MultipleUploadService } from "@common/uploadDocuments/services/multipleUpload.service";
import { ICustomScope } from "@common/crSelector/directives/paginated-subj-list/paginated-subj-list.directive";
import { Document } from "@common/model/_adocument";
import { BreadCrumb } from "@common/model/breadCrumb";
import { UploadDocument } from "@common/model/UploadDocument";

export interface IEcvOrganize {
    documentTypes: Array<any>;
    document: UploadDocument;
    providerTypes: Array<any>;
    postDate: any;
    redirectTo: string;
    select: boolean;
    shareTooltip: string;
    sharedWith: Array<any>;
    util: any;
    loading: boolean;

    init(): void;

    openDatePicker(doc): void;

    addFile($file, $errFile, isLink): void;

    cancel(): void;
}


class EcvOrganize implements IEcvOrganize {
    documentTypes: Array<any>;
    document: UploadDocument;
    multipleDocuments: Array<any>;
    providerTypes: Array<any>;
    dateOptions: any;
    postDate: any;
    subject: Subject;
    photoFile: any;
    $validationProvider: any;
    redirectTo: string;
    disableControl: boolean = false;
    docFile: any;
    currentUser: User;
    select: boolean;
    shareTooltip: string;
    sharedWith: Array<any>;
    util: any;
    loading: boolean;
    breadcrumb;
    folderId;
    maxUploadSize = 0;
    maxDocuments;
    currentUsage;
    titleErrors;
    maxSelectLimit = 10;
    displayFor: string;
    fieldKey: string = ORGANIZE_MODULE;
    filenames: Array<any>;
    disableUpload: boolean;
    ORGANIZE_MODULE: string;
    FORMS_MODULE: string;
    crntFldr: boolean;
    callback: Function;
    isUploadPermited: boolean;
    isResourceFolder: boolean;
    folderNames: string[];
    showDocDetails: boolean;
    enableVideoURLDoc: boolean;
    folderModule: string;
    postTypeEnums;
    static $inject = ["CacheService", "TeamVaultService", "UserService", "CommonService",
        "PopUpService", "$stateParams", "$injector", "$rootScope", "$timeout",
        "ApiAdapterService", "$state", "$q", "$window", "$element", "$sce", "PaymentService", "$uibModal",
        "DocumentFolderService", "UtilityService", "SnackbarService", "MultipleUploadService", 'TeamRoleService', 'CachingService', "PermissionService", '$scope'];

    constructor(
        private $_cache: CacheService,
        private $_team: TeamVaultService,
        private $_user: IUserService,
        private CommonService: CommonService,
        private PopUpService: PopUpService,
        private $stateParams: angular.ui.IStateParamsService,
        private $injector: angular.auto.IInjectorService,
        private $rootScope: IAppRootScopeService,
        private $timeout: angular.ITimeoutService,
        private ApiAdapterService: JavaApiAdapterService,
        private $state: angular.ui.IStateService,
        private $q: angular.IQService,
        private $window: angular.IWindowService,
        private $element: angular.IAugmentedJQuery,
        private $sce: angular.ISCEService,
        private PaymentService: PaymentService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private $_docFolderSvc: DocumentFolderService,
        private $_utility: UtilityService,
        private $_snack: SnackbarService,
        private $_multiUpld: MultipleUploadService,
        private $_teamRoleService: ITeamRoleService,
        private $_caching: ICachingService,
        private PermissionService: PermissionService,
        private $scope: ng.IScope
    ) {
        this.loading = true;
        this.util = Util;
        this.shareTooltip = $sce.trustAsHtml(Util.SHARE_WITH_SECURITY_TOOLTIP.replace(/displayAs/g, 'document'));
        this.multipleDocuments = [];
        this.titleErrors = [];
        this.FORMS_MODULE = FORMS_MODULE;
        this.ORGANIZE_MODULE = ORGANIZE_MODULE;
        this.$scope.$on('$destroy', () => {
            this.multipleDocuments.length = 0;
        });
        this.isUploadPermited = true;
        this.isResourceFolder = false;
        this.postTypeEnums = PostTypeEnums;

    }

    init(): void {
        if (!this.filenames) {
            this.filenames = [];
        }
        if (!this.multipleDocuments) {
            this.multipleDocuments = [];
        }
        this.folderId = this.$state.params.folderId;
        if (!!extModule) {
            this.maxDocuments = -1;
            this.currentUsage = 0;
        } else {
            this.ApiAdapterService.getCurrentSubscribePlanForUser(false).then((s) => {
                this.maxUploadSize = s.maxUploadSize;
                this.maxDocuments = s.maxDocuments;
                this.currentUsage = s.currentUsage.documents;
            });

            this.currentUser = this.$_cache.getUser();

            this.ApiAdapterService.getDocumentTypes().then((data) => {
                this.documentTypes = data;
            });
            this.subject = this.$_cache.getCurrentSubject();
        }
        this.dateOptions = {
            formatYear: 'yy',
            startingDay: 1,
            class: () => {
                return 'ecv-dtpicker'
            }
        };

        let proceed = () => {
            if (!this.subject) {
                this.loading = false;
                this.disableControl = true;
                this.$rootScope.forceCRSelection();
            } else {
                this.disableControl = false;
                if (this.currentUser.organizationId == 0) {   //For non-org user
                    this.$_docFolderSvc.getBrdcrmbFromFolderId(this.folderId, FOLDER_MODULES.DOCUMENT).then((fldrs) => {
                        this.loading = false;
                        this.breadcrumb = fldrs;
                    })
                } else {    //For org user
                    if (this.folderId == "") {    //If action initiated from carefeed page
                        //Fetch subject folder
                        this.$_docFolderSvc.getBrdcrmbFromSubjectId(this.subject.subjectId, FOLDER_MODULES.DOCUMENT).then((subFldrs) => {
                            this.loading = false;
                            this.breadcrumb = subFldrs;
                        });
                    } else {       //If action initiated from a folder
                        this.$_docFolderSvc.fetchFolderHierarchy(this.folderId, FOLDER_MODULES.DOCUMENT, null).then((fldrs: DocumentFolder[]) => {
                            let crntFldr = fldrs.find(f => f.id == this.folderId);
                            //If folder is of the same subject as selected
                            if (!!crntFldr && crntFldr.subjectId == this.subject.subjectId) {
                                this.crntFldr = true;
                                this.loading = false;
                                this.breadcrumb = this.$_docFolderSvc.createExtBreadcrumb(fldrs);
                            } else {
                                //If folder is not of the same subject then fetch the subject folder
                                this.$_docFolderSvc.getBrdcrmbFromSubjectId(this.subject.subjectId, FOLDER_MODULES.DOCUMENT).then((subFldrs: BreadCrumb[]) => {
                                    let subFldr = subFldrs.find(s => s.type == FolderTypeCodes.SYSTEM_SUBJECT);
                                    this.folderId = subFldr.id;
                                    this.loading = false;
                                    this.breadcrumb = subFldrs;
                                });
                            }
                        });
                    }
                }

                this.subject.loading = true;
                this.ApiAdapterService.getTeamMembers(this.subject.subjectId).then(
                    (s) => {
                        this.subject.teamMembers = s;
                        this.subject.loading = false;
                    }, () => {
                        this.subject.loading = false;
                    });
            }
        }
        let checkPermission = () => {
            if (!!this.subject && !this.isResourceFolder) {
                this.$_teamRoleService.getTeamRoleNames(this.subject.teamOrgId).then((s) => {
                    this.providerTypes = s;
                });
                this.$_user.isUserTeammember(this.subject).then((s) => {
                    if (!s) {
                        this.PermissionService.isActionAllowed(this.subject.teamPartyId, TargetEnum.DOCUMENT, PermissionsEnum.CREATE).then((isPermited) => {
                            this.isUploadPermited = isPermited
                        })
                    }
                });
            }
            else if (this.isResourceFolder) {
                this.$_teamRoleService.getTeamRoleNames(this.currentUser.organizationId).then((s) => {
                    this.providerTypes = s;
                });
            }
        };
        if (this.displayFor == FORMS_MODULE) {
            this.loading = false;
            this.disableControl = this.disableUpload;
            checkPermission();
        } else {
            if (this.folderId) {
                this.$_docFolderSvc.getBrdcrmbFromFolderId(this.folderId, FOLDER_MODULES.DOCUMENT).then((fldrs: BreadCrumb[]) => {
                    let crntFldr = fldrs.find(f => f.id == this.folderId);
                    this.enableVideoURLDoc = (!!this.$_docFolderSvc.isActionAllowed(crntFldr.allowedOperation, FolderStatusCodes.LINK_CREATE) && this.$_cache.getFeatures().links);
                    if (!!crntFldr && (crntFldr.type == FolderTypeCodes.RESOURCE_LIBRARY || crntFldr.type == FolderTypeCodes.RESOURCE_LIBRARY_CHILD)) {
                        this.loading = false;
                        this.breadcrumb = fldrs;
                        this.disableControl = false;
                        this.isResourceFolder = true;
                        this.crntFldr = true;
                        //Add check to find if it is resource library folder  and upload is permitted or not.
                        if (this.isResourceFolder) {
                            this.PermissionService.isActionAllowed(this.currentUser.partyId, TargetEnum.RESOURCE_LIBRARY_DOCUMENT, PermissionsEnum.CREATE).then((isPermited: boolean) => {
                                this.isUploadPermited = isPermited
                            })
                        }
                        checkPermission();
                        //To avoid forceCRSelection on clicking anywhere around organize-container
                        this.$timeout(() => {
                            $('.organize-container').addClass("organize-container-rsrc-fldr").removeClass("organize-container");
                        }, 10);
                    } else {
                        proceed();
                        checkPermission();
                    }
                })
            } else {
                proceed();
                checkPermission();
            }
        }
        this.$validationProvider = this.$injector.get('$validation');
        this.sharedWith = [];
    }

    openFolder(folderId, folderType): void {
        if (folderType == FolderTypeCodes.RESOURCE_LIBRARY) {
            this.$state.go('documents-load', { action: 'list-rl' });
        } else if (folderType == FolderTypeCodes.RESOURCE_LIBRARY_CHILD) {
            this.$state.go('documents-load', { action: 'list-rl', stateParams: { folderId: folderId } });
        } else {
            this.$state.go('documents-load', { action: 'list-document', stateParams: { folderId: folderId } });
        }

    }

    openDatePicker(doc): void {
        doc.calendarOpened = true;
    }

    addFile(input, isFileDropped, isLink) {

        let slctdLen = this.multipleDocuments.length;
        let popupTitle = this.PaymentService.getPopupTitle('document');
        let popupMessage = this.PaymentService.getPopupMessage('document');
        if (this.currentUsage == this.maxDocuments) {
            this.PopUpService.openAccountLimitAlertPopup(popupTitle, popupMessage);
        } else if ((this.currentUsage + slctdLen) == this.maxDocuments) {
            toastr.success(this.PaymentService.getToastrMessage('document'));
        } else if (slctdLen == this.maxSelectLimit) {
            toastr.success(Util.UPLOAD_LIMIT_EXCEEDED_SHRT);
        } else {
            this.$rootScope.mainShowLoader = true;
            let files = (!isFileDropped ? input.files : input);
            let filesLength = !isLink ? files.length : 1;
            let failedFileIssue = {
                totalCnt: 0,
                issueType: ''
            };
            let excess = filesLength, totalFiles = slctdLen + filesLength;
            let uploadLimit = (this.maxDocuments > 0) ? (this.maxDocuments - this.currentUsage) : (this.maxSelectLimit + 1);
            if ((this.maxSelectLimit < uploadLimit) && (totalFiles > this.maxSelectLimit)) {
                excess = this.maxSelectLimit - slctdLen;
                excess = (filesLength < excess) ? filesLength : excess;
                toastr.success(Util.UPLOAD_LIMIT_EXCEEDED.replace('$limit', '' + this.maxSelectLimit));
            } else if (this.maxDocuments > 0 && totalFiles > uploadLimit) {
                let uploadLimitExcess = uploadLimit - slctdLen;
                excess = (filesLength < uploadLimitExcess) ? filesLength : uploadLimitExcess;
                let msg = this.PaymentService.getToastrMessage('document') + Util.FILES_DISCARDED.replace('$limit', '' + uploadLimit);
                toastr.success(msg);
            }
            let res = [];
            if (!isLink) {
                for (let i = 0; i < excess; i++) {
                    let file = files[i];
                    this.docFile = null;
                    file.filename = file.name;
                    if (!this.$_team.checkDocument(file, true)) {
                        failedFileIssue['issueType'] = 'fileType';
                        failedFileIssue['totalCnt']++;
                        continue;
                    }

                    if (isIE11 && file.size > Util.DOCSIZE_THRESOLD) {
                        failedFileIssue['issueType'] = 'fileSizeIEThresold';
                        failedFileIssue['totalCnt']++;
                        continue;
                    }

                    if (file.filename.length > 99) {
                        let ext = this.CommonService.getExtension(file.filename.toLowerCase());
                        file.filename = file.filename.substr(0, 100 - (ext.length + 1)) + '.' + ext;
                    }

                    this.loading = true;
                    if ((file.size && file.size > 0) && (!!extModule || file.size <= (this.maxUploadSize * 1024 * 1024))) {
                        let ext = this.CommonService.getExtension(file.filename.toLowerCase());
                        this.document = new UploadDocument();
                        this.document.isPanelOpen = (i == excess - 1);
                        this.document.filename = file.filename;
                        this.displayFor != FORMS_MODULE && !this.isResourceFolder && this.subject && (this.document.subjectId = this.subject.subjectId);
                        this.document['displayedFileName'] = this.document.filename.slice(0, ((ext.length + 1) * (-1)));
                        this.document.title = file.filename.slice(0, ((ext.length + 1) * (-1)));
                        this.document.extension = ext;
                        this.document.keywords = file.type;
                        this.document.docFile = {
                            extension: ext,
                            type: this.document.keywords.indexOf('image') == 0 ? 'image' : 'document'
                        };
                        this.document.calendarOpened = false;
                        this.document.size = this.$_utility.getFileSize(file.size);
                        this.document.photoFile = file;
                        this.document.uplId = i + '-' + new Date().getTime();
                        this.displayFor != FORMS_MODULE && (this.document.documentFolderId = this.folderId);
                        this.document.postDate = new Date();
                        this.displayFor != FORMS_MODULE && (this.document.documentFolderType = this.breadcrumb[this.breadcrumb.length - 1].type);
                        this.document.postType = PostTypeEnums.DOCUMENT;
                        res.push(this.document);
                        this.filenames.push({
                            uplId: this.document.uplId,
                            fullFilename: this.document.filename,
                            filename: this.document['displayedFileName'],
                            extension: ext
                        });
                        if (!!this.callback) {
                            this.callback();
                        }
                    } else {
                        failedFileIssue['issueType'] = (file.size == 0) ? 'fileSizeZero' : 'fileSize';
                        failedFileIssue['totalCnt']++;
                    }
                }
                input.value = '';
            } else {
                this.document = new UploadDocument();
                this.document.isPanelOpen = true;
                this.displayFor != FORMS_MODULE && !this.isResourceFolder && this.subject && (this.document.subjectId = this.subject.subjectId);
                this.document.keywords = '';
                this.document.docFile = {
                    type: 'document',
                    postType: PostTypeEnums.LINK
                };
                this.document.postType = PostTypeEnums.LINK;
                this.document.linkType = 'YOUTUBE';
                this.document.calendarOpened = false;
                this.document.uplId = new Date().getTime();
                this.displayFor != FORMS_MODULE && (this.document.documentFolderId = this.folderId);
                this.document.postDate = new Date();
                this.displayFor != FORMS_MODULE && (this.document.documentFolderType = this.breadcrumb[this.breadcrumb.length - 1].type);

                res.push(this.document);
                if (!!this.callback) {
                    this.callback();
                }
            }
            this.$timeout(() => {
                this.multipleDocuments = this.multipleDocuments.concat(res);
            }, 10);
            this.loading = false;
            this.$rootScope.mainShowLoader = false;
            if (!!failedFileIssue['totalCnt']) {
                let msg = '';
                if (totalFiles == 1) {
                    msg = 'The file';
                    if (failedFileIssue['issueType'] == 'fileSize') {
                        msg += ' is larger than ' + this.maxUploadSize + 'MB and'
                    }
                    if (failedFileIssue['issueType'] == 'fileType') {
                        msg += "'s type is unsupported and the file"
                    }
                    msg += " was not selected.";

                    if (failedFileIssue['issueType'] == 'fileSizeIEThresold') {
                        msg = Util.IE_UPLOAD_NOT_ALLOWED_LG_DOC;
                    }
                    if (failedFileIssue['issueType'] == 'fileSizeZero') {
                        msg = Util.DOC_NO_CONTENT;
                    }
                } else {
                    msg = 'One or more files were not selected due to being the wrong type or being too large or having no content.';
                }
                toastr.success(msg, null, 7000);
            }


        }
    }

    //Autofill title and description on change of YouTube video url
    autoFillForVideoUrl(uplId: number): void {
        //regex which will match video id
        let ind = this.multipleDocuments.findIndex(function (d) {
            return d.uplId == uplId;
        });
        if (ind > -1) {
            this.document = this.multipleDocuments[ind];
            let regexToMatchVideoId = /[?&]v=([^&#]+)|youtu\.be\/([^?]+)/;
            let videoIdMatch = this.document.url.match(regexToMatchVideoId);
            //If the YouTube video url is of short url form i.e. YouTube.be, then match will be in 2nd index of array
            //otherwise it will be on 1st index
            if (this.youtubeLink(this.document.url) && videoIdMatch) {
                let videoId = videoIdMatch[1] || videoIdMatch[2];
                //Calling API to get YouTube video details
                this.ApiAdapterService.getYtVideoDetails(videoId).then((res) => {
                    if (res) {
                        this.document.title = res.title;
                        this.document.comment = res.description;
                    } else {
                        this.document.title = "";
                        this.document.comment = "";
                    }
                })
                    .catch((error) => {
                        console.error("Error fetching data from YouTube API", error);
                        this.document.title = "";
                        this.document.comment = "";
                    });
            } else {
                this.document.title = "";
                this.document.comment = "";
            }
        }
    }

    proceedShare(form: any): void {
        if (!this.multipleDocuments[0].subject && !!this.multipleDocuments[0].subjectId) {
            this.multipleDocuments[0].subject = this.subject;
        }
        this.$validationProvider.validate(form).success(() => {
            this.multipleDocuments.forEach(item => {
                item.title = item.title.replace(/\s\s+/g, ' ');
            });
            this.$rootScope.mainShowLoader = true;
            if (this.isResourceFolder) {  //If resource folder skip share
                this.setSharedMembers({
                    "participants": [],
                    "participantsOrgs": []
                });
                this.uploadDocuments();
            } else {
                console.log("Opening share window:", this.multipleDocuments);
                let item = this.multipleDocuments;
                let icon = this.$sce.trustAsHtml("<i class='fa fa-files-o'></i>");
                let iconBgColor = "#f4cd02";
                let msgs = {};
                msgs['noSharedUsersMsg'] = Util.NO_SHARED_USERS_DOCUMENT;
                msgs['title'] = Util.SHARE_UPLOAD_TITLE;
                msgs['chsTmTitle'] = Util.SELECT_TM_TITLE;
                msgs['shrdTitle'] = Util.MULTIPLE_SHARED_AREA_TITLE;
                msgs['shareTooltip'] = this.$sce.trustAsHtml(Util.SHARE_WITH_SECURITY_TOOLTIP.replace(/displayAs/g, "document"));
                let eligibleUsers = this.$_team.getUsersEligibleForShare(item[0].subjectId || null, item[0].id || null, null, item[0].postType || null);

                this.PopUpService.openSharePopup(item, "new", eligibleUsers, item[0].documentUsers, 'document', true, icon, iconBgColor, true, msgs).then((s) => {
                    this.setSharedMembers(s);
                    this.uploadDocuments();
                }, () => this.clearSharedMembers());
            }
        })
            .error((message) => {
                this.titleErrors = this.titleErrors.concat(Object.keys(form.$error));
                // this.PopUpService.openInformationModal(Util.CORRECT_ERRORS);
                this.PopUpService.openInformationModal(Util.CORRECT_ERRORS, this.titleErrors);
                this.$rootScope.mainShowLoader = false;
                console.log("Validation Error:", JSON.stringify(message));
            });
    }

    goToTeamsFolder = () => {
        let tmFldr = this.breadcrumb.find(b => b.type == FolderTypeCodes.ENTERPRISE_TEAMS);
        this.$state.go('documents-load', { action: 'list-document', stateParams: { folderId: tmFldr.id } });
    }

    uploadDocuments = () => {
        if (!!this.redirectTo && this.redirectTo == 'cf') {
            this.$state.go('parent-carefeed');
        } else if (!!this.redirectTo && (this.redirectTo == 'docs' || this.redirectTo == 'menu')) {
            if (this.isResourceFolder) {
                this.$state.go('documents-load', { action: 'list-rl', stateParams: { folderId: this.folderId } });
            } else if (this.currentUser.organizationId == 0 || !!this.crntFldr) {
                this.$state.go('documents-load', { action: 'list-document', stateParams: { folderId: this.folderId } });
            } else {
                this.goToTeamsFolder();
            }
        }
        this.$_multiUpld.startUploadTasks(this.multipleDocuments);
    }

    cancel(): void {
        this.$_cache.setTempDocument(null);
        if (this.redirectTo == 'cf') {
            this.$state.go('parent-carefeed');
        } else if (this.redirectTo == 'discs') {
            this.$state.go('discussions-load',{action:'discussion-board',stateParams:{}});
        } else if (this.redirectTo == 'menu' || this.redirectTo == 'docs') {
            if (this.currentUser.organizationId == 0 || !!this.crntFldr || !this.breadcrumb) {
                this.$window.history.back();
            } else {
                this.goToTeamsFolder();
            }
        }
    }

    getSharedList = (): User[] => {
        if (this.subject && this.subject.teamMembers) {
            return this.subject.teamMembers.filter(tm => tm.permissionType != 'NOT_SHARED' && tm.id != this.currentUser.userId);
        } else {
            return [];
        }
    }

    setSharedMembers = (obj): void => {
        let members = obj.participants;
        let orgs = obj.participantsOrgs || [];
        for (let document of this.multipleDocuments) {
            document.documentUsers = [];
            for (let member of members) {
                console.log("Setting share for member", member, member.permissionType);
                let shareMember = this.subject.teamMembers.find(tm => tm.id == member.id);
                if (!shareMember) {
                    this.subject.teamMembers.push(member);
                }
                if (member.permissionType != 'NOT_SHARED') {
                    !!document && (document.documentUsers.push(member));
                }
            }
            document.orgUsers = orgs;
        }
    }

    clearSharedMembers = (): void => {
        for (let shareMember of this.subject.teamMembers || []) {
            shareMember.permissionType = 'NOT_SHARED';
            shareMember.sharedChecked = false;
        }
    }

    disableSubmit = (): boolean => {
        return this.multipleDocuments.length == 0 || this.disableControl;
    }

    deSelect = ($event, uplId) => {
        $event.preventDefault();
        $event.stopPropagation();
        let ind = this.multipleDocuments.findIndex(d => d.uplId == uplId);
        if (ind > -1) {
            this.multipleDocuments.splice(ind, 1);
        }
        ind = this.filenames.findIndex(d => d.uplId == uplId);
        if (ind > -1) {
            this.filenames.splice(ind, 1);
        }
    }

    isTitleAndLinkValid = (title, url, uplId) => {
        return (this.titleErrors.includes('title-' + uplId) && (!title || title.trim() == ''))
            || (this.titleErrors.includes('url-' + uplId) && (!url || url.trim() == '' || !this.youtubeLink(url)));

    }

    youtubeLink = (value) => {
        if (!!value) {
            return Util.youtubeUrlRegex.test(value);
        } else
            return false;
    }
}

function organize(): ng.IDirective {
    return {
        restrict: 'E',
        replace: true,
        controller: EcvOrganize,
        controllerAs: 'organizeVm',
        scope: true,
        bindToController: {
            'uploadType': '@',
            'multipleDocuments': '=?',
            'fieldKey': '@?',
            'redirectTo': '=?redirectTo',
            'displayFor': '@?',
            'maxSelectLimit': ' @?',
            'filenames': '=?',
            'disableUpload': '=?',
            'callback': '=?',
            'showDocDetails': '=?',
            'folderNames': '=?'
        },
        link: (scope: ICustomScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvOrganize): void => {
            scope.contentUrl = (attributes.uploadType == 'multiple') ? 'app/common/uploadDocuments/components/organize/templates/organize.directive.html' : 'app/common/uploadDocuments/components/organize/templates/single-upload.directive.html';
            controller.init();
        },
        template: '<div ng-include="contentUrl"></div>'
    }
}

angular.module('eCareVault.common.uploadDocuments').directive('ecvOrganize', organize);
